import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  async toggle(event) {
    const element = this.element;
    event.preventDefault();
    $.ajax({
      method: 'PATCH',
      url: element.getAttribute('href'),
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function (result) {
        const span = element.querySelector('span');
        if(span.classList.contains('btn-light-public')){
          span.classList.remove('btn-light-public');
          span.classList.add('btn-light-disable')
          span.innerText = '-';
        }else{
          span.classList.add('btn-light-public');
          span.classList.remove('btn-light-disable')
          span.innerText = '是';
        }

      },
      error: function (xhr) {
        console.log(xhr);
      }

    });



  }
}
